export const paymentConstants = {
  PAYMENT_REQUEST: 'PAYMENT_REQUEST',
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  PAYMENT_FAILURE: 'PAYMENT_FAILURE',

  PAYMENT_GET_REQUEST: 'PAYMENT_GET_REQUEST',
  PAYMENT_GET_SUCCESS: 'PAYMENT_GET_SUCCESS',
  PAYMENT_GET_FAILURE: 'PAYMENT_GET_FAILURE',
};
